import { Reveal } from "../Reveal";
import { Overline } from "../SectionHeading";

const CHAPTERS = [
  { num: "01", title: "By Hand", text: "Every piece finished one at a time" },
  { num: "02", title: "Small Batch", text: "Made slowly, never mass-produced" },
  { num: "03", title: "For Her", text: "Designed around real women, real days" },
];

export const OurStory = () => (
  <section id="our-story" className="scroll-mt-24 overflow-hidden bg-brand-cream py-20 sm:py-28 lg:py-36" data-testid="our-story-section">
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <Overline>Our Story</Overline>
        <h2 className="mt-5 font-serif text-4xl font-medium leading-[1.1] tracking-tight text-brand-charcoal sm:text-5xl lg:text-6xl text-balance">
          Bracelets for every chapter.
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="mt-8 space-y-5 text-base leading-relaxed text-brand-stone">
          <p>
            At HESHAURA, we believe bracelets are more than just adornments — they hold memories, moments and
            meanings. Designed for real women, our bracelets blend modern elegance with everyday comfort, so you
            can carry your story beautifully, always.
          </p>
          <p>
            Every design still begins with a simple question:
            <em className="font-serif text-lg text-brand-charcoal"> would she wear this?</em> Same you. Brighter
            always.
          </p>
        </div>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-12 grid grid-cols-3 gap-6 border-t border-brand-gold/30 pt-8">
          {CHAPTERS.map((c) => (
            <div key={c.num}>
              <p className="font-serif text-sm italic text-brand-gold/70">Chapter {c.num}</p>
              <p className="mt-1 font-serif text-2xl font-medium text-brand-gold sm:text-3xl">{c.title}</p>
              <p className="mt-1.5 text-[11px] leading-snug uppercase tracking-[0.16em] text-brand-stone">{c.text}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
